// @ts-ignore
import generatedEnums from './gen/graph'

const graphConstants = {
  enums: generatedEnums
}

export default  graphConstants
